export function isChecklistArchived(archivedAt?: string): boolean {
  return typeof archivedAt === "string" && archivedAt.length > 0;
}

export function partitionChecklists<
  T extends { ownerId: string; archivedAt?: string; name: string; updatedAt?: string },
>(
  checklists: T[],
  mySub: string,
  nameFilter: string
): {
  activeOwn: T[];
  activeShared: T[];
  archived: T[];
  hasAnySharedActive: boolean;
  filterActive: boolean;
} {
  const q = nameFilter.trim().toLowerCase();
  const matches = (c: T) => !q || c.name.toLowerCase().includes(q);
  const filtered = checklists.filter(matches);
  const active = filtered.filter((c) => !isChecklistArchived(c.archivedAt));
  const archived = filtered
    .filter((c) => isChecklistArchived(c.archivedAt))
    .sort((a, b) =>
      (b.archivedAt ?? b.updatedAt ?? "").localeCompare(a.archivedAt ?? a.updatedAt ?? "")
    );
  return {
    activeOwn: active.filter((c) => c.ownerId === mySub),
    activeShared: active.filter((c) => c.ownerId !== mySub),
    archived,
    hasAnySharedActive: checklists.some(
      (c) => c.ownerId !== mySub && !isChecklistArchived(c.archivedAt)
    ),
    filterActive: q.length > 0,
  };
}
